function Button({
  children,
  onClick,
  loading,
  disabled,
  reference,
  type = "button",
  color = "#212529",
}) {
  const handleClick = (e) => {
    if (loading || disabled) {
      e.preventDefault();
      return;
    }

    if (onClick) onClick(e);
  };

  return (
    <button
      ref={reference}
      onClick={handleClick}
      type={type}
      disabled={loading || disabled}
      style={{
        padding: "0.5rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        backgroundColor: color,
        color: "#fff",
        border: "none",
        borderRadius: "0.5rem",
        cursor: "pointer",
        width: "100%",
        transition: "background-color 0.3s, transform 0.2s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor =
          color === "#212529" ? "#343a40" : color;
        e.currentTarget.style.transform = "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = color;
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      {loading ? <p>Cargando...</p> : children}
    </button>
  );
}

export default Button;
